import { css } from '@emotion/css'
import { fontSize, spacing, fontFamily, breakpoint } from '../../styles'
import { mediaQueryHelper } from '../../styles/helpers'
import getThemeColors, { colors } from '../../themes'

const styles = {
  wrapper: css({
    display: 'inline-flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    flexDirection: 'column',
    fontFamily: fontFamily.body,

    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',
    },
  }),

  label: css({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: fontSize.default,
    lineHeight: 1,
    minHeight: 30, // To match the attachment height,
    flex: '0 0 auto',

    '&:hover': {
      textDecoration: 'underline',
    },

    '& > * + *': {
      marginLeft: spacing.small,
    },
  }),

  input: css({
    display: 'none',
  }),

  attachments: css({
    // Negative margins to compensate for the margins around the attachments
    margin: -spacing.extraSmall,
    marginTop: spacing.default,
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',

    [mediaQueryHelper(breakpoint.phone)]: {
      paddingLeft: spacing.medium,
      marginTop: -spacing.extraSmall,
    },
  }),

  file: css({
    margin: spacing.extraSmall,
    maxWidth: 250,

    '& > span': {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
  }),

  errorWrapper: css({
    flex: '0 0 100%',
    marginTop: spacing.default,
  }),
}

export default styles

export const labelColor = theme => {
  if (theme === 'light') {
    return css({
      color: colors.jumbo,
    })
  }

  const themed = getThemeColors(theme)
  return css({
    color: themed.base,
  })
}
